module.exports = __webpack_public_path__ + "img/folder.f45519b3.png";